import { useState } from "react";
import PropTypes from "prop-types";
import { PictureOutlined, DeleteOutlined, EditOutlined } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import "@/assets/styles/image_picker.css";
import EditMemberDialog from "@/ui/Edit_Member";

const MemberPicker = ({
  members = [],
  onOpenModal,
  onDeleteMember,
  onUpdateMember,
  className = "",
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const handleDeleteClick = (member) => {
    onDeleteMember(member);
  };

  const handleEditClick = (member) => {
    setSelectedMember(member);
    setIsEditModalVisible(true);
  };

  const handleOpenPicker = () => {
    onOpenModal?.();
  };

  const MemberPickerBox = () => (
    <button
      type="button"
      onClick={handleOpenPicker}
      className="flex-shrink-0 flex flex-col items-center justify-center gap-2
        border-2 border-dashed border-gray-300 rounded-md cursor-pointer
        transition-all duration-200 hover:border-primary bg-secondary w-24 h-24 sm:w-32 sm:h-32">
      <PictureOutlined className="text-2xl text-gray-400" />
      <span className="text-xs text-gray-400">Add New</span>
    </button>
  );

  const SelectedMember = ({ member }) => (
    <div className="relative flex-shrink-0 w-24 h-24 sm:w-32 sm:h-32">
      <div className="w-full h-full border-2 border-dashed border-gray-300 rounded-md overflow-hidden relative">
        <Avatar
          src={member.profileImage || member.avatar || undefined}
          alt={member.name || "Member"}
          size="full"
          className="!block"
        />
        <div className="absolute inset-0 bg-black/40 hover:bg-black/50 flex flex-col items-center justify-center gap-2 transition-colors duration-200">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => handleEditClick(member)}
              className="text-white active:scale-95 transition-transform duration-150">
              <EditOutlined className="text-2xl drop-shadow-[0_2px_2px_rgba(0,0,0,0.5)]" />
            </button>
            <button
              type="button"
              onClick={() => handleDeleteClick(member)}
              className="text-white active:scale-95 transition-transform duration-150">
              <DeleteOutlined className="text-2xl drop-shadow-[0_2px_2px_rgba(0,0,0,0.5)]" />
            </button>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-[10px] text-white text-center px-1 truncate w-full font-medium drop-shadow-[0_2px_2px_rgba(0,0,0,0.5)]">
              {member.name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );

  SelectedMember.propTypes = {
    member: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      profileImage: PropTypes.string,
      avatar: PropTypes.string,
      role: PropTypes.string,
    }),
  };

  return (
    <>
      <div className={`relative ${className}`}>
        <div className="flex overflow-x-auto gap-4 pb-2 scrollbar-hide">
          <MemberPickerBox />
          {members.map((member, index) => (
            <SelectedMember key={index} member={member} />
          ))}
        </div>
      </div>

      <EditMemberDialog
        isVisible={isEditModalVisible}
        onClose={() => setIsEditModalVisible(false)}
        member={selectedMember}
        onUpdateMember={onUpdateMember}
      />
    </>
  );
};

MemberPicker.propTypes = {
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      profileImage: PropTypes.string,
      avatar: PropTypes.string,
      role: PropTypes.string,
    })
  ),
  onOpenModal: PropTypes.func,
  onDeleteMember: PropTypes.func,
  onUpdateMember: PropTypes.func,
  className: PropTypes.string,
};

export default MemberPicker;
